import React from "react"

import Layout from "./Layout"

const Page = ({ children, title }) => <Layout title={title}>{children}</Layout>

export default Page
